/**
 * Category Constants
 */

import type { Category } from '../types/entry';

export const CATEGORIES: readonly Category[] = [
  'work',
  'health',
  'creative',
  'social',
  'personal',
  'learning',
] as const;

export interface CategoryMeta {
  name: Category;
  label: string;
  icon: string; // Lucide icon name
  description: string;
}

export const CATEGORY_META: Record<Category, CategoryMeta> = {
  work: {
    name: 'work',
    label: 'Work',
    icon: 'briefcase',
    description: 'Professional achievements',
  },
  health: {
    name: 'health',
    label: 'Health',
    icon: 'heart',
    description: 'Physical and mental wellness',
  },
  creative: {
    name: 'creative',
    label: 'Creative',
    icon: 'palette',
    description: 'Art, music, writing, creation',
  },
  social: {
    name: 'social',
    label: 'Social',
    icon: 'users',
    description: 'Relationships, connections',
  },
  personal: {
    name: 'personal',
    label: 'Personal',
    icon: 'home',
    description: 'Life admin, self-care',
  },
  learning: {
    name: 'learning',
    label: 'Learning',
    icon: 'book-open',
    description: 'Education, skills, growth',
  },
} as const;
